import React, { useState } from 'react'
import { Table } from '@wework/dieter-ui'

export default function InteractableListItem({
  children,
  style,
  onMouseOver,
  onMouseOut,
  data,
  onClick,
}) {
  const [isHovered, setIsHovered] = useState(false)
  const _onMouseOverHandler = event => {
    onMouseOver && onMouseOver(data)
  }

  const _onMouseOutHandler = event => {
    onMouseOut && onMouseOut(data)
  }

  const _onClickHandler = event => {
    onClick && onClick(data)
  }

  if (!children) {
    return null
  }

  return (
    <Table.Row
      className="unbordered-table"
      onMouseEnter={e => {
        _onMouseOverHandler(e)
        setIsHovered(true)
      }}
      onMouseOut={e => {
        _onMouseOutHandler(e)
        setIsHovered(false)
      }}
      style={{ ...style, backgroundColor: isHovered ? '#eee' : '#fff' }}
      onClick={_onClickHandler}
    >
      {children}
    </Table.Row>
  )
}
